$(function() {
  $('[data-toggle="popover"], .has-popover').popover();

  // Close any opened popover when any modal is opened
  $('body').on('shown.bs.modal', function() {
    $("[data-toggle=popover], .has-popover").popover('hide')
  });
});
